import { useCallback } from 'react';
import {
  trackEvent,
  trackDonate,
  trackVolunteerSignup,
  trackNewsletterSignup,
  trackSocialShare,
  trackButtonClick,
  trackFormSubmission,
  trackNavigation,
} from '@utils/analytics';

// Custom hook for tracking events
export function useAnalytics() {
  const trackCustomEvent = useCallback(
    (action: string, category: string, label?: string, value?: number) => {
      trackEvent(action, category, label, value);
    },
    []
  );

  const trackDonateEvent = useCallback((amount: number, currency?: string) => {
    trackDonate(amount, currency);
  }, []);

  const trackVolunteerSignupEvent = useCallback((formSection: string) => {
    trackVolunteerSignup(formSection);
  }, []);

  const trackNewsletterSignupEvent = useCallback((source: string) => {
    trackNewsletterSignup(source);
  }, []);

  const trackSocialShareEvent = useCallback((platform: string) => {
    trackSocialShare(platform);
  }, []);

  const trackButtonClickEvent = useCallback((buttonName: string, location: string) => {
    trackButtonClick(buttonName, location);
  }, []);

  const trackFormSubmissionEvent = useCallback((formName: string, success: boolean) => {
    trackFormSubmission(formName, success);
  }, []);

  const trackNavigationEvent = useCallback((from: string, to: string) => {
    trackNavigation(from, to);
  }, []);

  return {
    trackCustomEvent,
    trackDonate: trackDonateEvent,
    trackVolunteerSignup: trackVolunteerSignupEvent,
    trackNewsletterSignup: trackNewsletterSignupEvent,
    trackSocialShare: trackSocialShareEvent,
    trackButtonClick: trackButtonClickEvent,
    trackFormSubmission: trackFormSubmissionEvent,
    trackNavigation: trackNavigationEvent,
  };
}

// Hook for tracking button clicks with automatic cleanup
export function useTrackClick(componentName: string, location?: string) {
  return useCallback(
    (eventName?: string) => {
      trackButtonClick(eventName || componentName, location || 'unknown');
    },
    [componentName, location]
  );
}
